import { useTheme } from "@hooks";
import { constants } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      userSelect: "none",
      cursor: "pointer",
      padding: constants.divPadding,
      borderRadius: constants.radius.view,
      backgroundColor: theme.goal.share.background,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    title: {
      color: theme.goal.share.text.default,
      textAlign: "center",
    },
    subtitle: {
      color: theme.goal.share.text.secondary,
      textAlign: "center",
    },
  };

  return styles;
};
